import styled from "styled-components";

const SectionTitle = styled.div`
  color: var(--accentColor);
  font-size: 19px;
  max-width: 300px;
  font-weight: 900;
  font-family: var(--headingFont);
  color: var(--element);
  text-transform: uppercase;
`;

export default SectionTitle;
